import { HttpResponse, delay, http } from 'msw';

import { getCustomHandlerLoginStatus } from './utils';
import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformListSyncRunsMockHandler = () => {
  return http.get('*/teams/:team/syncs/:sync_name/runs', async () => {
    await delay(MOCK_DELAY);

    if (!getCustomHandlerLoginStatus()) {
      return new HttpResponse(null, { status: 401 });
    }

    const items = [
      {
        completed_at: undefined,
        created_at: '2024-06-17T14:09:04.884907Z',
        errors: 1,
        id: 'f475f3ec-52b5-4fdd-bbef-b9bc0bc7e177',
        status: 'started',
        sync_name: 'gcp-gcs-2024-06-17',
        total_rows: 32,
        warnings: 0,
      },
    ];

    return HttpResponse.json(
      {
        items,
        metadata: {
          last_page: 1,
          page_size: 10,
          time_ms: 100,
          total_count: items.length,
        },
      },
      {
        status: 200,
      },
    );
  });
};
